import { render, staticRenderFns } from "./mediaPublishUpload.vue?vue&type=template&id=5089c977&scoped=true&"
import script from "./mediaPublishUpload.vue?vue&type=script&lang=js&"
export * from "./mediaPublishUpload.vue?vue&type=script&lang=js&"
import style0 from "./mediaPublishUpload.vue?vue&type=style&index=0&id=5089c977&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089c977",
  null
  
)

component.options.__file = "mediaPublishUpload.vue"
export default component.exports